import { IClients } from '@llws/lift-entity-interfaces';
import { getFileLoc } from './get-file-loc';
import { getS3Url } from './get-s3-url';

export const getClientLogoURL = (client: Pick<IClients, 'clientKey' | 'primaryLogo'>) => {
  let logoUrl = '/img/default-user.png';
  const prefix = getFileLoc(getS3Url()!, client.clientKey, 'images/logos', '').replace('_staging', ''); // hack for staging release....
  if (client.primaryLogo) {
    logoUrl = `${prefix}${client.primaryLogo}`;
  }
  return logoUrl;
};
